import React from 'react';
import { 
  ColumnHeightOutlined,
  ColumnWidthOutlined,
  ExpandAltOutlined
} from '@ant-design/icons';

const FloatingToolbar = ({ 
  isVisible, 
  position, 
  onToolClick,
  direction = 'below' // 'below', 'right', 'left', 'above'
}) => {
  if (!isVisible) return null;

  const tools = [
    {
      id: 'fillHeight',
      icon: ColumnHeightOutlined,
      label: 'Preencher Altura Total'
    },
    {
      id: 'fillWidth',
      icon: ColumnWidthOutlined,
      label: 'Preencher Largura Total'
    },
    {
      id: 'fillAll',
      icon: ExpandAltOutlined,
      label: 'Preencher Todo Espaço'
    }
  ];

  // Calcular transform baseado na direção
  const getTransform = () => {
    switch (direction) {
      case 'below':
        return 'translate(-50%, 0)';
      case 'above':
        return 'translate(-50%, -100%)';
      case 'right':
        return 'translate(0, -50%)';
      case 'left':
        return 'translate(-100%, -50%)';
      default:
        return 'translate(-50%, 0)';
    }
  };

  // Renderizar seta baseado na direção
  const renderArrow = () => {
    const arrowClass = "flex justify-center";
    
    switch (direction) {
      case 'below':
        return (
          <div className={`${arrowClass} mb-1`}>
            <div className="w-0 h-0 border-l-4 border-r-4 border-b-4 border-transparent border-b-gray-300"></div>
          </div>
        );
      case 'above':
        return (
          <div className={`${arrowClass} mt-1`}>
            <div className="w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-300"></div>
          </div>
        );
      case 'right':
        return (
          <div className="flex items-center mr-1">
            <div className="w-0 h-0 border-t-4 border-b-4 border-r-4 border-transparent border-r-gray-300"></div>
          </div>
        );
      case 'left':
        return (
          <div className="flex items-center ml-1">
            <div className="w-0 h-0 border-t-4 border-b-4 border-l-4 border-transparent border-l-gray-300"></div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div 
      className="fixed z-50 pointer-events-auto"
      style={{
        left: position.x,
        top: position.y,
        transform: getTransform()
      }}
    >
      {renderArrow()}
      
      {/* Toolbar */}
      <div className={`bg-white rounded-md shadow-2xl border border-gray-200 p-1.5 flex items-center ${direction === 'right' || direction === 'left' ? 'flex-col space-y-1' : 'space-x-1'}`}>
        {tools.map((tool) => {
          const IconComponent = tool.icon;
          return (
            <button
              key={tool.id}
              onClick={() => onToolClick(tool.id)}
              className="bg-gray-100 hover:bg-gray-200 text-gray-700 p-2 rounded-md transition-all duration-200 transform hover:scale-[1.03] hover:shadow-md group relative focus-visible:ring-2 focus-visible:ring-blue-500"
              title={tool.label}
            >
              <IconComponent className="icon-xs" />
              
              {/* Tooltip */}
              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1.5 px-1.5 py-0.5 bg-gray-900 text-white text-[10px] rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                {tool.label}
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-2 border-r-2 border-t-2 border-transparent border-t-gray-900"></div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FloatingToolbar;
